import React from "react";

const SocialLinks = () => {
  return (
    <div>
      <ul className="socialLinks">
        <li>
          <a
            href="https://www.facebook.com/suman.maharana.75/"
            target="_blank"
          >
            <span className="fab fa-facebook"></span>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/i_am_kirraa/" target="_blank">
          <span className="fab fa-instagram"></span>
          </a>
        </li>
        <li>
          <a href="https://twitter.com/sumantheshine" target="_blank">
          <span className="fab fa-twitter"></span>
          </a>
        </li>
        <li>
          <a href="https://wa.me/+917894887909" target="_blank">
          <span className="fab fa-whatsapp"></span>
          </a>
        </li>
        <li>
          <a href="https://github.com/thisissuman" target="_blank">
          <span className="fab fa-github"></span>
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/sumanmaharana222888/"
            target="_blank"
          >
          <span className="fab fa-linkedin"></span>
          </a>
        </li>
        <li>
          <a href="https://codepen.io/thisissuman" target="_blank">
          <span className="fab fa-codepen"></span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialLinks;
